__turbopack_context__.v({
  "badge": "entry-list-module-scss-module__7WdY6G__badge",
  "divider": "entry-list-module-scss-module__7WdY6G__divider",
  "entry": "entry-list-module-scss-module__7WdY6G__entry",
  "id": "entry-list-module-scss-module__7WdY6G__id",
  "list": "entry-list-module-scss-module__7WdY6G__list",
  "meta": "entry-list-module-scss-module__7WdY6G__meta",
  "space": "entry-list-module-scss-module__7WdY6G__space",
  "status": "entry-list-module-scss-module__7WdY6G__status",
  "statusChanged": "entry-list-module-scss-module__7WdY6G__statusChanged",
  "statusDraft": "entry-list-module-scss-module__7WdY6G__statusDraft",
  "statusPublished": "entry-list-module-scss-module__7WdY6G__statusPublished",
  "title": "entry-list-module-scss-module__7WdY6G__title",
  "type": "entry-list-module-scss-module__7WdY6G__type",
});
